var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3465 18.7052V11.6267C38.2379 14.4418 39.9683 18.2454 40.1854 22.2838C40.4088 26.438 39.0134 30.5171 36.2921 33.6641C33.5708 36.8111 29.7362 38.7808 25.5927 39.1596L25.4563 39.172V39.3089V45.2105V45.3712L25.6166 45.3602C31.4332 44.9608 36.861 42.2973 40.7367 37.9412C44.6119 33.5854 46.6255 27.8839 46.3453 22.0605C46.0712 16.3632 43.6229 10.9934 39.5135 7.05191H46.9996H47.1496V6.90191V1.00034V0.850336H46.9996H32.2457C31.4233 0.850336 30.6347 1.17713 30.0531 1.75853L30.0531 1.75857C29.4717 2.34018 29.1449 3.12875 29.1449 3.95112V3.97493L29.1449 3.97511V18.7052V18.8552H29.2949H35.1965H35.3465V18.7052Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85016 46L1.85016 46.15H2.00016H16.7541C17.5765 46.15 18.3651 45.8232 18.9467 45.2418L18.9467 45.2418C19.5281 44.6601 19.8549 43.8716 19.8549 43.0492V28.2953V28.1453H19.7049H13.8033H13.6533V28.2953V35.3514C11.2592 33.3098 9.51492 30.6089 8.63968 27.5817C7.7351 24.4524 7.80221 21.1219 8.83239 18.0316C9.86257 14.9413 11.8071 12.2366 14.4085 10.2757C17.0096 8.31507 20.1453 7.19067 23.3995 7.05144L23.5431 7.04529V6.90157V1V0.844806L23.388 0.850087C18.8791 1.00361 14.5233 2.52214 10.8964 5.20495C7.26928 7.88757 4.54203 11.6082 3.07521 15.8744L3.0752 15.8744C1.60869 20.1408 1.4716 24.7521 2.68234 29.0975C3.85646 33.3121 6.24452 37.0844 9.54487 39.9475H2H1.85L1.85 40.0975L1.85016 46Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReload);
export default __webpack_public_path__ + "static/media/icon_reload.e571249b66d29f29ee81b75064fed5e9.svg";
export { ForwardRef as ReactComponent };